<script setup lang="ts">import { ref as _ref } from 'vue';

import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons'

const revealPassword = _ref(false)
</script>

<template>
  <GInput
    field="password"
    placeholder="Enter Your Password"
    required="Please enter your password."
    :type="revealPassword ? 'text' : 'password'"
  >
    <template #addonRight>
      <GIconButton
        v-tooltip="`Click to ${revealPassword ? 'hide' : 'show'} password`"
        :icon="revealPassword ? faEyeSlash : faEye"
        tabindex="-1"
        @click.prevent="revealPassword = !revealPassword"
      />
    </template>
  </GInput>
</template>
